import Button from '../../Button'
import { Header } from '../../Modal'
import Box from '../../Modal/Box'
import Buttons from '../../Modal/Buttons'
import { Content } from '../../Modal/Content'
import { Container } from '../Container'

function ModalSizeL({ children }) {
  return (
    <Container label='Modal, size L - 720px, max height - 560px'>
      <Box size='l'>
        <Header text='Header text' />
        <Content size='l'>{children}</Content>
        <Buttons size='l'>
          <Button.Contained text='Save' />
          <Button.Outlined text='Cancel' />
        </Buttons>
      </Box>
    </Container>
  )
}

export default ModalSizeL
